import ScopeConstants from "constants/ScopeConstants"

export const ChargeRateScope = {
    key: ScopeConstants.CHARGE_RATE,
    selector: (state) => state.chargeRates,
    tokenSelector: (state) => state.authentication.token,
    fetchEndpoint: "/api/ChargeRate/Standard/Rates/",
    updateEndpoint: "/api/ChargeRate/Update/",
    deleteEndpoint: "/api/ChargeRate/Delete/"
}